export default [{
  path: '/booking/index',
  name: 'booking-index',
  title: '预约统计',
  component: () => import('@/views/booking/index')
}, {
  path: '/bookAnalyse/index',
  name: 'bookAnalyse-index',
  title: '详情',
  component: () => import('@/views/booking/template/bookAnalyse/index')
}];
